import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { HOST_URL } from "../../utils/misc";

const CardContentIntro = (props) => {
    const renderCategoriesData = () => (
        props.templates.categoriesData.categories.length > 0 ?
        props.templates.categoriesData.categories.map((item, index) => (            
            <div className="col-md-3 col-xs-12 mt-4 productType">
                <Link to={`/products/${item.categoryName}`}>
                    <img src={HOST_URL + item.image} style={{ width:"100%" }} />
                    <div className="textProductType">
                        <h6 style={{ paddingTop:"20%", fontSize:20 }}>{item.categoryName}</h6>
                    </div>
                    <div className="fadedbox">
                        <div className="title text">
                            <h6>{item.categoryName}</h6> 
                            <div style={{ fontSize:12 }}>
                                <b>Xem thêm <i className="fa fa-arrow-right" aria-hidden="true"></i></b>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )) : null
    )
    if(props.templates && props.templates.categoriesData) {
        return (
            <>
            <div className="container">
                <div className="row">
                    {renderCategoriesData()}
                </div>
            </div>
            </>
        );
    }
    return (null)
};

const mapStateToProps = (state) => {
    return {
        products: state.products,
        cart: state.cart,
        templates: state.templates,
    };
};
  
export default connect(mapStateToProps)(CardContentIntro);
  